import * as React from "react";

import { EntryType } from "../Compo/CompoPage";

export const EntryIcon = (props: { type: EntryType }) => {
  const icons: { [key in EntryType]: string } = {
    song: "fa-music",
    story: "fa-book",
    art: "fa-paint-brush",
  };

  const icon = icons[props.type];

  return <i className={`fa ${icon} text-black`}></i>;
};
